import { push } from '@lagunovsky/redux-react-router'
import HomeAction from 'home/actions/HomeAction'
import { isUndefined, orderBy } from 'lodash'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import { hasValue } from 'utils/NumberUtil'
import { H_MAT_SENSOR } from '../../../../account/constants/AccessRulesConstants'
import { PATH_MATERIEL_SENSOR } from '../../../../home/constants/RouteConstants'
import DtoHydrometricStation from '../../../../hydrometry/dto/DtoHydrometricStation'
import DtoInstallation from '../../../../installation/dto/installation/DtoInstallation'
import DtoPiezometerLight from '../../../../piezometry/dto/DtoPiezometerLight'
import PluviometerDto from '../../../../pluviometry/dto/PluviometerDto'
import DtoQualitometerLight from '../../../../quality/dto/DtoQualitometerLight'
import CityDto from '../../../../referencial/components/city/dto/CityDto'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import ReferencialAppList from '../../../../referencial/components/ReferencialAppList'
import { getDate } from '../../../../utils/DateUtil'
import { componentHasHabilitations } from '../../../../utils/HabilitationUtil'
import { createIconMaterialState, getAssignmentLabel } from '../../../../utils/MaterielUtils'
import MaterielAssignmentLink from '../../MaterielAssignmentLink'
import { getLabel } from '../../../../utils/StoreUtils'
import { searchAllCharacters } from '../../../../utils/StringUtil'
import { LIST_PANEL, MAP_PANEL, MAT_HEADERS_SENSORS } from '../../../constants/MaterielConstants'
import DtoMaterielState from '../../../dto/DtoMaterielState'
import SensorFilterForm from '../../filterPanel/SensorFilterForm'
import MaterielsMapComponent from '../../map/MaterielsMapComponent'
import SensorAction from '../actions/SensorAction'
import DtoSensorSituation from '../dto/DtoSensorSituation'
import DtoSensorType from '../dto/DtoSensorType'
import SensorDto from '../dto/SensorDto'
import { Grid } from '@mui/material'
import { darkBlue } from 'utils/constants/ColorTheme'

class SensorsApp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            view: LIST_PANEL,
            filter: this.getFilter(),
        }
    }

    getFilter = () => {
        const { globalResearch, location } = this.props
        const matType = queryString.parse(location.search)?.idType
        return {
            matType: isUndefined(matType) ? undefined : parseInt(matType),
            searchValue: globalResearch,
        }
    }

    componentDidMount() {
        if (!componentHasHabilitations(H_MAT_SENSOR)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        this.props.setHelpLink('materiel', '')
        if (!this.props.sensors.length) {
            this.props.fetchSensors(true)
        }
        if (!this.props.sensorTypes.length) {
            this.props.fetchSensorTypes()
        }
        this.props.updateGlobalResearch('')
    }

    getHash = mat => searchAllCharacters(MAT_HEADERS_SENSORS.map(key => mat[key]).join(''))

    getFilterMateriels = materiels => {
        const {
            network,
            state,
            administrator,
            manufacturer,
            matType,
            range,
            length,
            displayEquipment,
            searchValue,
            displayOutOfService,
        } = this.state.filter
        const filterEquipment = !displayEquipment ? materiels.filter(({ isEquipment }) => !isEquipment) : materiels
        const filterAdministrator = administrator ? filterEquipment.filter(({ administratorId }) => administrator === administratorId) : filterEquipment
        const filterManufacturer = manufacturer ? filterAdministrator.filter(({ manufacturerId }) => manufacturer === manufacturerId) : filterAdministrator
        const filterStatusCode = hasValue(state) ? filterManufacturer.filter(({ statusCode }) => statusCode === state) : filterManufacturer
        const filterType = matType ? filterStatusCode.filter(({ materielType }) => materielType === matType) : filterStatusCode
        const filterLength = length ? filterType.filter(mat => mat.length === length) : filterType
        const filertRange = range ? filterLength.filter(mat => `${mat.range ?? ''}`.trim().toLowerCase() === `${range}`.trim().toLowerCase()) : filterLength
        const filterNetwork = network ? filertRange.filter(({ networkCode }) => network === networkCode) : filertRange
        const filterOutOfService = displayOutOfService ? filterNetwork : filterNetwork.filter(({ statusCode }) => statusCode !== 0 && statusCode !== 5 && statusCode !== 6)
        const searchValueFormated = searchAllCharacters(searchValue)
        return searchValue ? filterOutOfService.filter(mat => this.getHash(mat).includes(searchValueFormated)) : filterOutOfService
    }

    getExportData = (materiels) => {
        if (!materiels.length) {
            return []
        }
        const [head, ...tail] = materiels
        return [{ ...head, headers: [...MAT_HEADERS_SENSORS, 'comment'] }, ...tail]
    }

    getPanel = sensors => {
        if (this.state.view === MAP_PANEL) {
            return (
                <MaterielsMapComponent
                    materielLink={PATH_MATERIEL_SENSOR}
                    materiels={sensors}
                />
            )
        }
        const formattedSensors = sensors.map(mat => ({
            ...mat,
            state: createIconMaterialState(mat.state, mat.statusCode),
            assignment: <MaterielAssignmentLink materiel={mat} />,
            scale: { value: mat.range, sortValue: ['', undefined, null].includes(mat.range) ? null : Number(mat.range) },
            length: { value: mat.length, sortValue: ['', undefined, null].includes(mat.length) ? null : Number(mat.length) },
        }))

        return (
            <ReferencialAppList
                title={i18n.sensors}
                data={formattedSensors}
                exportData={this.getExportData(sensors)}
                type={{ headers: MAT_HEADERS_SENSORS }}
                newAction={() => this.props.push('/materiel/sensor/new')}
                onClick={({ materielId }) => this.props.push(`/materiel/sensor/${materielId}`)}
                showNewButton={true}
                showPurgeButton={false}
                setTitleAction={HomeAction.setTitle([{
                    title: i18n.materiel,
                    href: 'materiel',
                }, {
                    title: i18n.sensors,
                    href: 'materiel/sensor',
                }])}
                searchable={false}
                useNewTable
                color={darkBlue}
            />
        )
    }

    onChangeView = view => {
        this.setState({ view })
    }

    onValidate = filter => {
        this.setState({ filter })
    }

    getCorrespondingSite = ({ siteType, siteCode }) => {
        switch (siteType) {
            case 1:
                return this.props.piezometers.find(({ id }) => id === siteCode)
            case 2:
                return this.props.pluviometers.find(({ id }) => id === siteCode)
            case 3:
                return this.props.qualitometers.find(({ id }) => id === siteCode)
            case 4:
                return this.props.hydrometricStations.find(({ id }) => id === siteCode)
            case 7:
                return this.props.installations.find(({ id }) => id === siteCode)
            default:
                return {}
        }
    }

    getSensorType = () => this.props.sensorTypes.filter(({ id, label }) => !!this.props.sensors.find(({ sensorType }) => sensorType === id) && label).map(({ id, label }) => ({
        id,
        label,
    }))

    render() {
        const materiels = this.props.sensors.map(mat => {
            const lastSituation = this.props.sensorsLastSituations.find(s => s.idSensor === mat.id)
            const labelState = lastSituation ? getLabel(this.props.materielStates, lastSituation.statusCode) : ''
            const site = lastSituation && lastSituation.statusCode === 1 && lastSituation.siteType && lastSituation.siteCode && this.getCorrespondingSite(lastSituation) || {}
            const labelAssignment = (lastSituation && lastSituation.statusCode === 1 && getAssignmentLabel(site, lastSituation.siteName)) || ''
            const city = site.townCode && this.props.cities.find((o) => o.code === site.townCode) || undefined
            const cityLabel = city ? `${city.name} - [${city.code}]` : (site.townCode || '')
            const departmentLabel = city && city.departmentNumber ? city.departmentNumber : ''
            return {
                materielId: mat.id,
                type: getLabel(this.props.sensorTypes, mat.materielType),
                manufacturer: getLabel(this.props.contributors, mat.manufacturerId, 'labelDisplay', 'id'),
                state: labelState,
                statusCode: lastSituation && lastSituation.statusCode,
                stateDate: lastSituation && getDate(lastSituation.situationDate),
                city: cityLabel,
                administratorId: mat.administrator,
                serialNumber: mat.serialNumber,
                immoNum: mat.reference,
                assignment: labelAssignment,
                siteType: lastSituation && lastSituation.siteType,
                departmentShort: departmentLabel,
                purchaseDate: getDate(mat.purchaseDate),
                manufacturerId: mat.manufacturerId,
                networkCode: mat.networkCode,
                materielType: mat.materielType,
                range: mat.range,
                scale: mat.range,
                length: mat.length,
                comment: mat.comment,
                isEquipment: mat.isEquipment,
                siteCode: lastSituation && lastSituation.siteCode,
                administrator: getLabel(this.props.contributors, mat.administrator, 'labelDisplay', 'code'),
            }
        })
        const filteredMateriels = this.getFilterMateriels(materiels)
        return (
            <Grid container spacing={1}>
                <Grid size={12}>
                    <SensorFilterForm
                        view={this.state.view}
                        filter={this.state.filter}
                        changeView={this.onChangeView}
                        materiels={materiels}
                        typeList={orderBy(this.getSensorType(), 'label')}
                        onValidate={this.onValidate}
                    />
                </Grid>
                <Grid size={12}>
                    {this.getPanel(filteredMateriels)}
                </Grid>
            </Grid>
        )
    }
}

SensorsApp.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.object,
    }),
    allowModifications: PropTypes.bool,
    getLink: PropTypes.func,
    sensors: PropTypes.arrayOf(PropTypes.instanceOf(SensorDto)),
    sensorsLastSituations: PropTypes.arrayOf(PropTypes.instanceOf(DtoSensorSituation)),
    sensorTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSensorType)),
    cities: PropTypes.arrayOf(PropTypes.instanceOf(CityDto)),
    materielStates: PropTypes.arrayOf(PropTypes.instanceOf(DtoMaterielState)),
    piezometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerLight)),
    pluviometers: PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
    qualitometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualitometerLight)),
    hydrometricStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometricStation)),
    installations: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    fetchSensors: PropTypes.func,
    fetchSensorTypes: PropTypes.func,
    push: PropTypes.func,
    globalResearch: PropTypes.string,
    updateGlobalResearch: PropTypes.func,
    setHelpLink: PropTypes.func,
}

const mapStateToProps = store => ({
    sensors: store.SensorReducer.sensors,
    sensorsLastSituations: store.SensorReducer.sensorsLastSituations,
    sensorTypes: store.SensorReducer.sensorTypes,
    piezometers: store.PiezometryReducer.piezometersLight,
    pluviometers: store.PluviometryReducer.pluviometers,
    qualitometers: store.QualityReducer.qualitometersLight,
    hydrometricStations: store.HydrometryReducer.hydrometricStations,
    installations: store.InstallationReducer.installations,
    materielStates: store.MaterielReducer.materielStates,
    cities: store.CityReducer.cities,
    contributors: store.ContributorReducer.contributors,
    globalResearch: store.HomeReducer.globalResearch,
})

const mapDispatchToProps = {
    fetchSensors: SensorAction.fetchSensors,
    fetchSensorTypes: SensorAction.fetchSensorTypes,
    updateGlobalResearch: HomeAction.updateGlobalResearch,
    setHelpLink: HomeAction.setHelpLink,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(SensorsApp)
